

class Matrix<T> extends Array<Array<T>> {

    rowAmount: number
    colAmount: number

    constructor (rowAmount: number, colAmount: number, fill: T) {
        super()
        this.rowAmount = rowAmount
        this.colAmount = colAmount
        for (let i = 0; i < rowAmount; i ++) {
            const row: Array<T> = []
            for (let j = 0; j < colAmount; j ++) {
                row.push(fill)
            }
            this.push(row)
        }
    }

    static fromArray <T2> (arr: Array<Array<T2>>): Matrix<T2 | undefined> {
        const rowAmount = arr.length
        const colAmount = arr[0]?.length || 0
        const matrix = new Matrix<T2 | undefined>(rowAmount, colAmount, undefined)
        for (let i = 0; i < rowAmount; i ++) {
            matrix[i] = arr[i]
        }
        return matrix
    }

}


export { Matrix }
